interface Props {
  size?: number;
  className?: string;
}

/**
 * Minimalist house — matches Logo.tsx in shape language (currentColor,
 * solid fills with opacity for secondary parts, a soft baseline at the
 * bottom). Designed to slot in wherever the Boot Logo sits when the user
 * picks the Haus goal theme, so /Übersicht etc. don't fall back on the
 * 🏠 emoji.
 *
 * Reads at 16-px and 88-px alike: roof = primary mass, walls = secondary
 * (opacity 0.45 matching the jib in Logo), door + window outlined in the
 * same stroke weight as the mast.
 */
export default function HouseIcon({ size = 24, className = "" }: Props) {
  return (
    <svg
      viewBox="0 0 32 32"
      width={size}
      height={size}
      className={className}
      role="img"
      aria-label="Haus"
    >
      {/* Roof — solid triangle (primary mass, mirrors the main sail) */}
      <path d="M16 4 L28 14 L4 14 Z" fill="currentColor" />
      {/* Chimney */}
      <rect x="22" y="6" width="2.4" height="4.5" fill="currentColor" />
      {/* Walls — lighter so the silhouette reads roof-first */}
      <path
        d="M6 14 L26 14 L26 26 L6 26 Z"
        fill="currentColor"
        opacity="0.45"
      />
      {/* Door */}
      <rect
        x="14"
        y="19"
        width="4"
        height="7"
        fill="currentColor"
      />
      {/* Window */}
      <rect
        x="8.5"
        y="17"
        width="3.5"
        height="3.5"
        fill="currentColor"
      />
      {/* Window cross */}
      <line
        x1="10.25"
        y1="17"
        x2="10.25"
        y2="20.5"
        stroke="#0b0f19"
        strokeWidth="0.6"
      />
      <line
        x1="8.5"
        y1="18.75"
        x2="12"
        y2="18.75"
        stroke="#0b0f19"
        strokeWidth="0.6"
      />
      {/* Ground line — same treatment as Logo's water line */}
      <path
        d="M2.5 28.5 Q8 27 13 28.5 T24 28.5 T29.5 28"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinecap="round"
        fill="none"
        opacity="0.4"
      />
    </svg>
  );
}
